import type { Message as MessageType } from "@openanalyst-ai/sdk/v2/client"

export function isInterruptedEditTarget(messages: MessageType[], messageID: string) {
  const message = messages.find((item) => item.id === messageID)
  if (!message || message.role !== "user") return false
  if (messages.findLast((item) => item.role === "user")?.id !== message.id) return false
  return messages.some(
    (item) => item.role === "assistant" && item.parentID === message.id && item.error?.name === "MessageAbortedError",
  )
}
